import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../../core/services/http.service';

@Injectable()
export class RegisterService {

    constructor(
        private http: HttpService
    ) { }

    // getCaptcha() {
    //     return Observable.of({
    //         code: 'fsrd',
    //         url: 'http://fdsfdsfds.com/xxx.jpg'
    //     });
    // }

    getProtocol() {
        return this.http.get('api/open/srm/srmSupplierAudit/getProtocol', {})
            .switchMap(res => this.http.mapRes(res));
    }

    getArea() {
        return this.http.get('api/open/srm/srmSupplierAudit/getArea', {})
            .switchMap(res => this.http.mapRes(res));
    }

    getBusinessType() {
        return this.http.get('api/open/srm/srmSupplierAudit/getBusinessType', {})
            .switchMap(res => this.http.mapRes(res));
    }

    register(postbody) {
        return this.http.post('api/open/srm/srmSupplierAudit/Register', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    checkLoginName(postbody) {
        return this.http.post('api/open/srm/srmSupplierAudit/getUsername', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    checkPhone(postbody) {
        return this.http.post('api/open/srm/srmSupplierAudit/checkMobile', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    getTemplateInfo(code) {
        return this.http.post('api/open/srm/srmSupplierAudit/getTemplate', { code: code })
            .switchMap(res => this.http.mapRes(res));
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/register.service.ts